/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Footer_Link_Application_FormInputs */

const tr_legal_footer_link_application_form = /** @type {(inputs: Legal_Footer_Link_Application_FormInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başvuru Formu`)
};

const en_legal_footer_link_application_form = /** @type {(inputs: Legal_Footer_Link_Application_FormInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Application Form`)
};

const de_legal_footer_link_application_form = /** @type {(inputs: Legal_Footer_Link_Application_FormInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antragsformular`)
};

const ru_legal_footer_link_application_form = /** @type {(inputs: Legal_Footer_Link_Application_FormInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Форма обращения`)
};

/**
* | output |
* | --- |
* | "Application Form" |
*
* @param {Legal_Footer_Link_Application_FormInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const legal_footer_link_application_form = /** @type {((inputs?: Legal_Footer_Link_Application_FormInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Footer_Link_Application_FormInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_legal_footer_link_application_form(inputs)
	if (locale === "de") return de_legal_footer_link_application_form(inputs)
	if (locale === "ru") return ru_legal_footer_link_application_form(inputs)
	return tr_legal_footer_link_application_form(inputs)
});